import { AddressForm } from './Forms/AddressForm';
import { SimplePopoverUnifiedInput } from './SimpleUnifiedPopoverInput';

export const SimpleLabeledPopoverAddressInput = ({ name }: { name: string }) => {
  const getFieldName = (fieldName: string) => `${name}.${fieldName}`;

  return (
    <SimplePopoverUnifiedInput
      flex={1}
      label="Address"
      names={[
        getFieldName('recipient'),
        getFieldName('line_one'),
        getFieldName('line_two'),
        getFieldName('country'),
        getFieldName('state'),
        getFieldName('city'),
        getFieldName('zip_code'),
      ]}
      joiner=", "
      tabIndex={0}
      isHorizontal
    >
      <AddressForm name={name} ignoreOnBlur />
    </SimplePopoverUnifiedInput>
  );
};
